import EditaDocumentoFromComponent from '../components/EditaDocumentoFromComponent.vue'
import ComentariosDialogComponent from '../components/expediente/datos-generales/dialog-component/ComentariosDialogComponent.vue'
import EditarCursoProgramadoFormComponent from '../components/EditarCursoProgramadoFormComponent.vue'
import EditarResultadoC3FormComponent from '../components/EditarResultadoC3FormComponent.vue'
import CalificarCursoModalComponent from '../components/CalificarCursoModalComponent.vue'
import DesvincularCursoModal from '../components/DesvincularCursoModal.vue'
import EditaEvaluacionDesempeñoAcademicoDialogContent from '../components/desarrollo_policial/evaluacion-desempeño-academico/dialogs/EditaEvaluacionDesempeñoAcademicoDialogContent.vue'
import DisciplinaAdministrativaDialogContent from '../components/desarrollo_policial/evaluacion-desempeño/dialogs/DisciplinaAdministrativaDialogContent.vue'
import RegistroMovimientoArmaDialogComponent from '../components/armeria/InventarioArmas/dialog-component/RegistroMovimientoArmaDialogComponent.vue'
import EstatusArmaDialogComponent from '../components/armeria/InventarioArmas/dialog-component/EstatusArmaDialogComponent.vue'
import RegistrarNuevaLicenciaDialogComponent from '../components/armeria/licencia-oficial-colectiva/dialog-component/RegistrarNuevaLicenciaDialogComponent.vue'
import MostrarDetalleLicenciaDialogComponent from '../components/armeria/licencia-oficial-colectiva/dialog-component/MostrarDetalleLicenciaDialogComponent.vue'
import EditarLicenciaDialogComponent from '../components/armeria/licencia-oficial-colectiva/dialog-component/EditarLicenciaDialogComponent.vue'
import BajaLocDialogComponent from '../components/armeria/licencia-oficial-colectiva/dialog-component/BajaLocDialogComponent.vue'
import NuevaReferenciaDialogComponent from '../components/expediente/datos-generales/dialog-component/NuevaReferenciaDialogComponent.vue'
import ReferenciaPersonalDialogComponent from '../components/expediente/datos-generales/dialog-component/ReferenciaPersonalDialogComponent.vue'
import NuevaReferenciaLaboralDialogComponent from '../components/expediente/datos-generales/dialog-component/NuevaReferenciaLaboralDialogComponent.vue'
import ConfirmacionArchivadoDialogComponent from '@/components/expediente/datos-generales/dialog-component/ConfirmacionArchivadoDialogComponent.vue'
import MensajeConfirmacionListaArmasDialogComponent from '@/components/armeria/InventarioArmas/dialog-component/MensajeConfirmacionListaArmasDialogComponent.vue'
import RegistrarAsistenciaModal from '@/components/enlace_nuevo/dialog-content/RegistrarAsistenciaModal.vue'
import ListadoAsistenciasModal from '@/components/enlace_nuevo/dialog-content/ListadoAsistenciasModal.vue'
import MensajeConformacionRemoverLocDialogComponent from '@/components/armeria/personal-armamento/dialog-component/MensajeConformacionRemoverLocDialogComponent.vue'
import RegistroNuevaAuditoriaDialogComponent from '@/components/armeria/personal-armamento/dialog-component/RegistroNuevaAuditoriaDialogComponent.vue'
import RegistroArmaNuevaDialogComponent from '@/components/armeria/InventarioArmas/dialog-component/RegistroArmaNuevaDialogComponent.vue'
import EditarArmaDialogComponent from '@/components/armeria/InventarioArmas/dialog-component/EditarArmaDialogComponent.vue'
import RegistrarNuevaTrayectoriaLaboralDialogComponent from '@/components/expediente/trayectoria.laboral/dialog-component/RegistrarNuevaTrayectoriaLaboralDialogComponent.vue'
import EditarTrayectoriaLaboralDialogComponent from '@/components/expediente/trayectoria.laboral/dialog-component/EditarTrayectoriaLaboralDialogComponent.vue'
import ConfirmacionTercerArmaDialogComponent from '@/components/expediente/trayectoria.laboral/dialog-component/ConfirmacionTercerArmaDialogComponent.vue'
import ListadoEquiposAsignadosDialogComponent from '@/components/equipamiento/dialog-tipes/ListadoEquiposAsignadosDialogComponent.vue'
import RegistrarNuevaRemesaDialogComponent from '@/components/armeria/licencia-oficial-colectiva/dialog-component/RegistrarNuevaRemesaDialogComponent.vue'
import EditarRemesaDialogComponent from '@/components/armeria/licencia-oficial-colectiva/dialog-component/EditarRemesaDialogComponent.vue'
import CrearNuevoCupDialogComponent from '@/components/expediente/datos-generales/dialog-component/CrearNuevoCupDialogComponent.vue'
import EditarCupDialogComponent from '@/components/expediente/datos-generales/dialog-component/EditarCupDialogComponent.vue'
import NotificacionesPage from '@/views/NotificacionesPage.vue'
import ConfirmacionEliminarReferenciaDialogComponent from '@/components/expediente/datos-generales/dialog-component/ConfirmacionEliminarRefereneciaDialogComponent.vue'
import ConfirmacionEliminarCupDialogComponent from '@/components/expediente/datos-generales/dialog-component/ConfirmacionEliminarCupDialogComponent.vue'
import AgregarEstudioDialogComponent from '@/components/expediente/estudios/dialog-component/AgregarEstudioDialogComponent.vue'
import EditarEstudiosDialogComponent from '@/components/expediente/estudios/dialog-component/EditarEstudiosDialogComponent.vue'
import HistorialArmasDialogComponent from '@/components/armeria/InventarioArmas/dialog-component/HistorialArmasDialogComponent.vue'
import RegistrarConvocatoriasDialogComponent from '@/components/desarrollo_policial/convocatorias/dialog-component/RegistrarConvocatoriasDialogComponent.vue'
import EditarConvocatoriasDialogComponent from '@/components/desarrollo_policial/convocatorias/dialog-component/EditarConvocatoriasDialogComponent.vue'
import PersonalVinculadoConvocatoriaDialogComponent from '@/views/desarrollo_profesional/dialog-component/PersonalVinculadoConvocatoriaDialogComponent.vue'
import ConfirmacionVincularPersonalConvocatoria from '@/views/desarrollo_profesional/dialog-component/ConfirmacionVincularPersonalConvocatoria.vue'
import AsignarPersonalManualmenteConvocatoriaDialogComponent from '@/views/desarrollo_profesional/dialog-component/AsignarPersonalManualmenteConvocatoriaDialogComponent.vue'
import VerDetalleConvocatoriaDialogComponent from '@/views/desarrollo_profesional/dialog-component/VerDetalleConvocatoriaDialogComponent.vue'
import MensajeConfirmacionEliminarPersonalConvocatoria from '@/views/desarrollo_profesional/dialog-component/MensajeConfirmacionEliminarPersonalConvocatoria.vue'
import AccesoriosAsignadosDialogComponent from '@/components/armeria/AccesoriosAsignadosDialogComponent.vue'
import AsignarEquipamientoDialogContent from '@/components/equipamiento/dialog-tipes/AsignarEquipamientoDialogContent.vue'
import ObservacionesResultadoC3DialogComponent from '@/components/expediente/ObservacionesResultadoC3DialogComponent.vue'
import ConfirmarDesvincularCandidatoDialogComponent from '@/components/ConfirmarDesvincularCandidatoDialogComponent.vue'
import ConfirmarEliminarBiometricoDialogComponent from '@/components/ConfirmarEliminarBiometricoDialogComponent.vue'
import EditarCandidatoCalificacionDialogComponent from '@/components/EditarCandidatoCalificacionDialogComponent.vue'

export const DIALOG_TYPES = {
  DEFAULT: {
    type: 'DEFAULT',
    title: 'Diálogo por defecto',
    component: null,
    width: 480,
  },

  EDITAR_DOCUMENTO_REGISTRADO: {
    type: 'EDITAR_DOCUMENTO_REGISTRADO',
    title: 'Editar documento registrado',
    component: EditaDocumentoFromComponent,
    width: 400,
  },

  EDITAR_RESULTADO_C3: {
    type: 'EDITAR_RESULTADO_C3',
    title: 'Editar Resultado C3',
    component: EditarResultadoC3FormComponent,
    width: 720,
  },
  EDITAR_CURSO_PROGRAMADO: {
    type: 'EDITAR_CURSO_PROGRAMADO',
    title: 'Editar Capacitación programada',
    component: EditarCursoProgramadoFormComponent,
    width: 600,
  },

  CALIFICAR_CURSO: {
    type: 'CALIFICAR_CURSO',
    title: 'Calificar capacitación programada',
    component: CalificarCursoModalComponent,
    width: 600,
  },

  DESVINCULAR_CURSO: {
    type: 'DESVINCULAR_CURSO',
    title: 'Desvincular elemento de capacitacioón programada',
    component: DesvincularCursoModal,
    width: 600,
  },

  EDITAR_EVALUACION_DESEMPEÑO_ACADEMICO: {
    type: 'EDITAR_EVALUACION_DESEMPEÑO_ACADEMICO',
    title: 'Evaluación de desempeño académico',
    component: EditaEvaluacionDesempeñoAcademicoDialogContent,
    width: '90%',
  },

  EDITAR_EVALUACION_DISCIPLINA_ADMINISTRATIVA: {
    type: 'EDITAR_EVALUACION_DISCIPLINA_ADMINISTRATIVA',
    title: 'Evaluación de disciplina administrativa',
    component: DisciplinaAdministrativaDialogContent,
    width: '90%',
  },
  REGISTRO_MOVIMIENTO_ARMA: {
    type: 'REGISTRO_MOVIMIENTO_ARMA',
    title: 'Registro de movimiento de arma',
    component: RegistroMovimientoArmaDialogComponent,
    width: 600,
  },
  RESGITRO_ARMA_NUEVA: {
    type: 'RESGITRO_ARMA_NUEVA',
    title: 'Registro de arma nueva',
    component: RegistroArmaNuevaDialogComponent,
    width: 1070,
  },
  ESTATUS_ARMA_DIALOG_COMPONENT: {
    type: 'ESTATUS_ARMA_DIALOG_COMPONENT',
    title: 'Estatus de arma',
    component: EstatusArmaDialogComponent,
    width: 600,
  },
  EDITAR_ARMA_DIALOG_COMPONENT: {
    type: 'EDITAR_ARMA_DIALOG_COMPONENT',
    title: 'Editar arma',
    component: EditarArmaDialogComponent,
    width: 1070,
  },
  REGISTRAR_NUEVA_LICENCIA_OFICIAL_COLECTIVA: {
    type: 'REGISTRAR_NUEVA_LICENCIA_OFICIAL_COLECTIVA',
    title: 'Registrar nueva licencia oficial colectiva',
    component: RegistrarNuevaLicenciaDialogComponent,
    width: 800,
  },
  MOSTRAR_DETALLE_LICENCIA_OFICIAL_COLECTIVA: {
    type: 'MOSTRAR_DETALLE_LICENCIA_OFICIAL_COLECTIVA',
    title: 'Detalle de licencia oficial colectiva',
    component: MostrarDetalleLicenciaDialogComponent,
    width: 800,
  },
  EDITAR_LICENCIA_OFICIAL_COLECTIVA: {
    type: 'EDITAR_LICENCIA_OFICIAL_COLECTIVA',
    title: 'Editar licencia oficial colectiva',
    component: EditarLicenciaDialogComponent,
    width: 800,
  },
  BAJA_LOC: {
    type: 'BAJA_LOC',
    title: 'Registrar baja de LOC',
    component: BajaLocDialogComponent,
    width: 700,
    headerColor: 'secondary',
  },
  REGISTRAR_NUEVA_REFERENCIA: {
    type: 'REGISTRAR_NUEVA_REFERENCIA',
    title: 'Referencia vecinal',
    component: NuevaReferenciaDialogComponent,
    width: 720,
  },
  REGISTRAR_NUEVA_REFERENCIA_PERSONAL: {
    type: 'REGISTRAR_NUEVA_REFERENCIA_PERSONAL',
    title: 'Referencia personal',
    component: ReferenciaPersonalDialogComponent,
    width: 600,
  },
  REGISTRAR_NUEVA_REFERENCIA_LABORAL: {
    type: 'REGISTRAR_NUEVA_REFERENCIA_LABORAL',
    title: 'Referencia laboral',
    component: NuevaReferenciaLaboralDialogComponent,
    width: 600,
  },
  CONFIRMACION_ARCHIVAR_DOCUMENTO: {
    type: 'CONFIRMACION_ARCHIVAR_DOCUMENTO',
    title: 'Confirmación de archivado de documento',
    component: ConfirmacionArchivadoDialogComponent,
    width: 600,
  },
  CONFIRMACION_CANCELAR_ARMA: {
    type: 'CONFIRMACION_CANCELAR_ARMAS',
    title: 'Confirmación de cancelación de armas',
    component: MensajeConfirmacionListaArmasDialogComponent,
    width: 600,
  },
  REGISTRAR_ASISTENCIA: {
    type: 'REGISTRAR_ASISTENCIA',
    title: 'Registrar asistencia',
    component: RegistrarAsistenciaModal,
    width: 800,
  },
  LISTADO_DE_ASISTENCIAS: {
    type: 'LISTADO_DE_ASISTENCIAS',
    title: '',
    component: ListadoAsistenciasModal,
    width: 1200,
  },
  CONFIRMACION_REMOVER_PERSONAL_LOC: {
    type: 'CONFIRMACION_REMOVER_PERSONAL_LOC',
    title: 'Confirmación de remover personal LOC',
    component: MensajeConformacionRemoverLocDialogComponent,
    width: 600,
  },
  REGISTRAR_NUEVA_AUDITORIA: {
    type: 'REGISTRAR_NUEVA_AUDITORIA',
    title: 'Registrar nueva auditoría',
    component: RegistroNuevaAuditoriaDialogComponent,
    width: 600,
  },
  REGISTRAR_TRAYECTORIA_LABORAL: {
    type: 'REGISTRAR_TRAYECTORIA_LABORAL',
    title: 'Registrar nueva Trayectoria laboral',
    component: RegistrarNuevaTrayectoriaLaboralDialogComponent,
    width: 800,
  },
  EDITAR_TRAYECTORIA_LABORAL: {
    type: 'EDITAR_TRAYECTORIA_LABORAL',
    title: 'Editar Trayectoria laboral',
    component: EditarTrayectoriaLaboralDialogComponent,
    width: 800,
  },
  CONFIRMACION_TERCER_ARMA_PERSONAL: {
    type: 'CONFIRMACION_TERCER_ARMA_PERSONAL',
    title: 'Confirmación de tercer arma personal',
    component: ConfirmacionTercerArmaDialogComponent,
    width: 600,
  },
  LISTADO_EQUIPOS_ASIGNADOS: {
    type: 'LISTADO_EQUIPOS_ASIGNADOS',
    title: 'Listado de Equipos Asignados',
    component: ListadoEquiposAsignadosDialogComponent,
    width: 1000,
  },
  REGISTRAR_NUEVA_REMESA: {
    type: 'REGISTRAR_NUEVA_REMESA',
    title: 'Registrar nueva remesa',
    component: RegistrarNuevaRemesaDialogComponent,
    width: 800,
  },
  EDITAR_REMESA: {
    type: 'EDITAR_REMESA',
    title: 'Editar una remesa',
    component: EditarRemesaDialogComponent,
    width: 800,
  },
  LISTADO_NOTIFICACIONES: {
    type: 'LISTADO_NOTIFICACIONES',
    title: 'Notificaciones',
    component: NotificacionesPage,
    width: '90%',
  },
  CREAR_NUEVO_CUP: {
    type: 'CREAR_NUEVO_CUP',
    title: 'Registrar nuevo CUP',
    component: CrearNuevoCupDialogComponent,
    width: 600,
  },
  EDITAR_CUP: {
    type: 'EDITAR_CUP',
    title: 'Editar CUPS',
    component: EditarCupDialogComponent,
    width: 600,
  },
  CONFIRMACION_ELIMINAR_REFERENCIA: {
    type: 'CONFIRMACION_ELIMINAR_REFERENCIA',
    title: 'Confirmación de eliminación de referencia',
    component: ConfirmacionEliminarReferenciaDialogComponent,
    width: 600,
  },
  CONFIRMACION_ELIMINAR_CUP: {
    type: 'CONFIRMACION_ELIMINAR_CUP',
    title: 'Eliminar CUP',
    component: ConfirmacionEliminarCupDialogComponent,
    width: 480,
  },
  AGREGAR_ESTUDIO: {
    type: 'AGREGAR_ESTUDIO',
    title: 'Registrar Estudio',
    component: AgregarEstudioDialogComponent,
    width: 800,
  },
  EDITAR_ESTUDIO: {
    type: 'EDITAR_ESTUDIO',
    title: 'Editar Estudio',
    component: EditarEstudiosDialogComponent,
    width: 800,
  },
  HISTORIAL_ARMAS: {
    type: 'HISTORIAL_ARMAS',
    title: '',
    component: HistorialArmasDialogComponent,
    width: '90%',
  },
  REGISTRAR_CONVOCATORIA: {
    type: 'REGISTRAR_CONVOCATORIA',
    title: 'Registrar Convocatoria',
    component: RegistrarConvocatoriasDialogComponent,
    width: 1300,
  },
  EDITAR_CONVOCATORIA: {
    type: 'EDITAR_CONVOCATORIA',
    title: 'Editar Convocatoria',
    component: EditarConvocatoriasDialogComponent,
    width: 1300,
  },
  PERSONAL_VINCULADO_CONVOCATORIA: {
    type: 'PERSONAL_VINCULADO_CONVOCATORIA',
    title: 'Personal vinculado a la convocatoria',
    component: PersonalVinculadoConvocatoriaDialogComponent,
    width: 1000,
  },
  CONFIRMACION_VINCULAR_PERSONAL_CONVOCATORIA: {
    type: 'CONFIRMACION_VINCULAR_PERSONAL_CONVOCATORIA',
    title: 'Confirmación',
    component: ConfirmacionVincularPersonalConvocatoria,
    width: 600,
  },
  ASIGNAR_PERSONAL_MANUALMENTE_CONVOCATORIA: {
    type: 'ASIGNAR_PERSONAL_MANUALMENTE_CONVOCATORIA',
    title: 'Asignar personal a la convocatoria',
    component: AsignarPersonalManualmenteConvocatoriaDialogComponent,
    width: 500,
  },
  VER_DETALLE_CONVOCATORIA: {
    type: 'VER_DETALLE_CONVOCATORIA',
    title: 'Detalle de la convocatoria',
    component: VerDetalleConvocatoriaDialogComponent,
    width: 800,
  },
  CONFIRMACION_ELIMINAR_PERSONAL_CONVOCATORIA: {
    type: 'CONFIRMACION_ELIMINAR_PERSONAL_CONVOCATORIA',
    title: 'Mensaje de confirmación',
    component: MensajeConfirmacionEliminarPersonalConvocatoria,
    width: 600,
  },
  COMENTARIOS_DOCUMENTOS: {
    type: 'COMENTARIOS_DOCUMENTOS',
    title: 'Observaciones del documento',
    component: ComentariosDialogComponent,
    width: 500,
  },
  ACCESORIOS_ASIGNADOS_ARMAS: {
    type: 'ACCESORIOS_ASIGNADOS_ARMAS',
    title: 'Accesorios asignados',
    component: AccesoriosAsignadosDialogComponent,
    width: 600,
  },
  ASIGNAR_EQUIPAMIENTO: {
    type: 'ASIGNAR_EQUIPAMIENTO',
    title: 'Asignar equipamiento',
    component: AsignarEquipamientoDialogContent,
    width: 900,
  },
  OBSERVACIONES_RESULTADO_C3: {
    type: 'OBSERVACIONES_RESULTADO_C3',
    title: 'Tabla de observaciones',
    component: ObservacionesResultadoC3DialogComponent,
    width: 1100,
  },
  CONFIRMAR_DESVINCULAR_CANDIDATO: {
    type: 'CONFIRMAR_DESVINCULAR_CANDIDATO',
    title: 'Confirmación',
    component: ConfirmarDesvincularCandidatoDialogComponent,
    width: 600,
  },
  CONFIRMAR_ELIMINAR_BIOMETRICO: {
    type: 'CONFIRMAR_ELIMINAR_BIOMETRICO',
    title: 'Confirmación',
    component: ConfirmarEliminarBiometricoDialogComponent,
    width: 600,
  },
  EDITAR_CANDIDATO_CALIFICACION: {
    type: 'EDITAR_CANDIDATO_CALIFICACION',
    title: 'Editar calificación del candidato',
    component: EditarCandidatoCalificacionDialogComponent,
    width: 600,
  },
}
